import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useCollectionFilters } from '@/hooks/useCollectionFilters/useCollectionFilters'
import { usePublicCollectionFilters } from '@/hooks/usePublicCollectionFilters/usePublicCollectionFilters'
import { Collection } from '@/store/api/showcasesApi'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { createFiltersSelector, setFilters } from '@/store/slices/aggregatesSlice'
import { CollectionTagListComponent } from './CollectionTagListComponent'
import { FilterDrawerType } from '../CourseFiltersDrawer/types'

type Props = {
  type: FilterDrawerType
}

export const CollectionTagList = ({ type }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const getCollectionFilters = type === 'public' ? usePublicCollectionFilters : useCollectionFilters
  const { collectionFilters } = getCollectionFilters(type)

  const filters = useAppSelector((state) => createFiltersSelector(state, type))

  const handleFilterToggle = useCallback(
    (collection: Collection) => {
      const isActive = filters.collection.includes(collection.id)

      const updatedCollectionFilters = isActive
        ? filters.collection.filter((id) => id !== collection.id)
        : [...filters.collection, collection.id]

      dispatch(setFilters({ type, filters: { ...filters, collection: updatedCollectionFilters } }))

      const searchParams = new URLSearchParams(location.search)
      if (updatedCollectionFilters.length > 0) {
        searchParams.set('collection', updatedCollectionFilters.join(','))
      } else {
        searchParams.delete('collection')
      }
      navigate({ search: searchParams.toString() }, { replace: true })
    },
    [dispatch, filters, type, navigate, location.search],
  )

  return <CollectionTagListComponent type={type} collections={collectionFilters ?? []} onClick={handleFilterToggle} />
}
